import React from 'react';
export function AppendixCartographySlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-66">
      <div className="flex flex-col md:flex-row w-full h-full min-h-0" data-id="element-67">
        {/* Left Panel */}
        <div className="flex flex-col justify-center w-full md:w-[40%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-68">
          <p className="italic font-semibold mb-[clamp(0.5rem,1.5vw,1rem)] animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          animationDelay: '0.1s'
        }} data-id="element-69">
            Experiment 05
          </p>
          <h2 className="font-black tracking-tight text-white leading-[1.1] mb-[clamp(1rem,2vw,1.5rem)] animate-fade-slide" style={{
          fontSize: 'var(--h2-size)',
          animationDelay: '0.2s'
        }} data-id="element-70">
            Generative
            <br data-id="element-71" />
            cartography
          </h2>
          <p className="text-white/70 leading-relaxed animate-fade-slide" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.3s'
        }} data-id="element-72">
            Experimenting with auto-generated illustrated maps. AI landmark
            icons, experience hubs scored by POI density, hand-drawn road
            styling.
            <br data-id="element-73" />
            <br data-id="element-74" />
            Testing whether we can give every city a unique visual identity
            without a massive design team.
          </p>
        </div>

        {/* Right Panel */}
        <div className="flex-1 flex items-center justify-center p-[var(--slide-padding)] min-h-0 relative" data-id="element-75">
          <div className="w-full h-full relative rounded-xl overflow-hidden animate-fade-slide" style={{
          animationDelay: '0.4s'
        }} data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/bJygJxoWeUPKQfwW9s1swq/Generative_cartography1.png" alt="Generative cartography with hand-drawn landmarks" className="absolute inset-0 w-full h-full object-contain" style={{
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))'
          }} data-id="element-77" />
          </div>
        </div>
      </div>
    </section>;
}